import IApplicationState from 'app/types/state';

export function getCurrentAdmin(state: IApplicationState) {
  if (
    state.admins.adminsById !== undefined
    && state.admins.currentAdminId !== undefined
  ) {
    return state.admins.adminsById[state.admins.currentAdminId];
  }
  return {};
}

export function getCurrentFormAdmin(state: IApplicationState) {
  return {
    ...getCurrentAdmin(state),
    ...state.admins.requestedData,
  };
}

export function getAdmins(state: IApplicationState) {
  return {
    ...state.admins,
    currentAdmin: {
      ...getCurrentAdmin(state),
    },
  };
}

export function getFullStoryData(admin) {
  if (admin !== undefined && admin.id !== undefined && admin.id !== null) {
    const adminData = {
      id: admin.id,
      admin_id: admin.id,
      email: admin.email,
      displayName: `${admin.firstName} ${admin.lastName}`,
      adminname: `${admin.firstName} ${admin.lastName}`,
      name: `${admin.firstName} ${admin.lastName}`,
      organisation_id:
        admin !== undefined
        && admin.organisations !== undefined
        && admin.organisations[0] !== undefined
          ? admin.organisations[0].id
          : null,
    };
    return adminData;
  }
  return undefined;
}

export function getIntercomData(admin) {
  if (admin !== undefined && admin.id !== undefined && admin.id !== null) {
    const adminData = {
      id: admin.id,
      email: admin.email,
      name: `${admin.firstName} ${admin.lastName}`,
      customer_type: 'Organisation Admin',
    };
    return adminData;
  }
  return undefined;
}
